export const SET_SHOPPER_CALCULATOR_DATA = 'SET_SHOPPER_CALCULATOR_DATA';
export const UNSET_SHOPPER_CALCULATOR_DATA = 'UNSET_SHOPPER_CALCULATOR_DATA';
//export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';